import axios from "axios";

export default axios.create({
    baseURL: process.env.REACT_APP_BASEURL_API,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});
